import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "lb-shadow lb-tab-shadow" }, null, -1)
const _hoisted_2 = ["onContextmenu"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_context_menu_item = _resolveComponent("context-menu-item")!
  const _component_context_menu = _resolveComponent("context-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_a_tabs, {
      class: "lb-tab",
      size: "small",
      type: "editable-card",
      style: _normalizeStyle({ left: _ctx.left + 'px' }),
      hideAdd: true,
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
      onEdit: _ctx.onEdit,
      onChange: _ctx.onChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: tab.path,
            closable: tab.closable
          }, {
            tab: _withCtx(() => [
              _createElementVNode("span", {
                class: "nspan",
                onContextmenu: ($event: any) => (_ctx.openContextMenu($event, tab))
              }, _toDisplayString(tab.title), 41, _hoisted_2)
            ]),
            _: 2
          }, 1032, ["closable"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["style", "activeKey", "onEdit", "onChange"]),
    _createVNode(_component_context_menu, { name: "tab-menu" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cMenu, (item, i) => {
          return (_openBlock(), _createBlock(_component_context_menu_item, {
            key: i,
            divider: "",
            onItemClickHandle: ($event: any) => (_ctx.cMenuClick($event, item.action))
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont", `icon-${item.icon}`])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["onItemClickHandle"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}